import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { completeWorkflowStep } from 'modules/accommodations/features/reservations/api';

export const useMutationCompleteWorkflowStep = () => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(completeWorkflowStep, {
    onSuccess: () => {
      successToast(t('Step marked as resolved'));
      queryClient.invalidateQueries(QUERY_KEYS.RENTALS_CALCULATION_WORKFLOW_TASKS);
    },
    onError: (error: AxiosError) => {
      const errorMessage = error.response?.data as { ErrorDescription: string };
      errorToast(errorMessage?.ErrorDescription);
    },
  });
};
